$(document).ready(function () {
    if (location.pathname === '/cart') {
        // Check if delivery exists and remove it
        function checkDeliveryExists() {
            if ($('a:contains(Delivery Fee)').length) {
                console.log($('a:contains(Delivery Fee)')[0].parentElement.parentElement.children[3].children[0].children[0].children[2])
                $('a:contains(Delivery Fee)')[0].parentElement.parentElement.children[3].children[0].children[0].children[2].click()
            }
        }

        checkDeliveryExists()

        $('.cart__dynamic-checkout-buttons').hide()

        function validateCartItems() {
            $.getJSON('/cart.js', function (cart) {
                $('.custom-tybo-checkout').removeClass('disabled-btn')

                var cartHasMeals = false
                var mealsCount = 0

                $($('.shipping-method-tybo')[0].options[1]).prop('disabled', false)

                $(cart.items).each(function () {
                    //if (this.product_type == 'Weekly Meal' || this.product_type == 'Custom Meal' || this.product_type == 'Healthy Breakfast' || this.product_type == 'Smoothies') { 
                    mealsCount += this.quantity
                    cartHasMeals = true
                    //}  
                })

                if (cartHasMeals && mealsCount < 10) {
                    $('.custom-cart-qty-msg').show()
                    $('.custom-tybo-checkout').addClass('disabled-btn')
                }

            })
        }

        validateCartItems()

        $('.btn-cart-remove-item').click(function () {
            $('.custom-tybo-checkout').prop('disabled', true)
            $('.custom-cart-qty-msg').hide()
            $('.cart__dynamic-checkout-buttons').hide()
            setTimeout(function () {
                validateCartItems()
                $('.custom-tybo-checkout').prop('disabled', false)
            }, 2000);
        })

        $('body').on('click', '.quantity__button', function () {
            $('.custom-tybo-checkout').prop('disabled', true)
            $('.custom-cart-qty-msg').hide()
            $('.cart__dynamic-checkout-buttons').hide()
            setTimeout(function () {
                validateCartItems()
                $('.custom-tybo-checkout').prop('disabled', false)
            }, 2000);
        })

        $('.shipping-method-tybo').on('change', function () {
            $('#cart-shipping-address').hide()
            $('.pickup-availability-msg').hide()

            if ($(this).val() == 'Delivery') {
                $('#cart-shipping-address').show()
            }

            if ($(this).val() == 'Pickup') {
                $('.pickup-availability-msg').show()
            }
        })

        $('body').on('change', '#cart-referral-email', function () {
            var referralEmail = $(this).val() ? $(this).val().trim() : '';
            $.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: {
                    attributes: {
                        'Referral Email': referralEmail
                    }
                },
                dataType: 'json'
            });
        });

        // Calculate the delivery total
        function calculateDeliveryFee(queryType) {

            if (!$.trim($('#delivery-contact-name').val()).length
                || !$.trim($('#delivery-phone-number').val()).length
                || !$.trim($('#delivery-address').val()).length
                || !$.trim($('#delivery-city').val()).length
                || !$.trim($('#delivery-zip-code').val()).length
            ) {
                $('.delivery-fields-error').show()

                $('.calculate-fee').text('Calculate fee')
                $('.continue-delivery').text('Continue')

                $('.calculate-fee').removeAttr('disabled')
                $('.continue-delivery').removeAttr('disabled')
            } else {
                $('.delivery-fields-error').hide()

                var address = $('#delivery-address').val()
                address = address.replace(/[^a-zA-Z0-9 ]/g, '')

                $.ajax({
                    beforeSend: function (request) {
                        request.setRequestHeader("Authorization", 'Bearer 1|JJ4NzBl52YAilFok9knvLnLMyLsjYdvGsOZiVeOA5a9cc538');
                    },
                    type: "POST",
                    dataType: "json",
                    url: 'https://v1.tyboapi.com/api/mr-meal/get-distance',
                    async: false,
                    data: {
                        token: 'SyBqOlX9ocRR8GY4VA06sj44VACalsj4',
                        units: 'imperial',
                        origins: '3601+Vineland+Rd+suite+1+Orlando+Florida+32811',
                        address: address,
                        city: $('#delivery-city').val(),
                        state: 'Florida',
                        zip_code: $('#delivery-zip-code').val()
                    },
                    success: function (response) {
                        if (response.distance != 'invalid_distance') {
                            var distance = response.distance;
                            var deliveryFee = 0

                            console.log(distance)

                            if (response.from == 'Orlando') {
                                if (distance <= 10) {
                                    deliveryFee = 10
                                }
                                if (distance > 10 && distance <= 15) {
                                    deliveryFee = 12
                                }
                                if (distance > 15 && distance <= 30) {
                                    deliveryFee = 15
                                }
                                /*if (distance > 25 && distance <= 30) {
                                  deliveryFee = 15
                                }*/
                            }

                            /*if (response.from == 'Tampa') {
                              deliveryFee = 15
                            }*/

                            if (queryType == 'calculate') {
                                console.log(response)
                                if (deliveryFee != 0) {
                                    $('.view-delivery-fee').html('Your delivery fee is $' + deliveryFee)
                                    $('.continue-delivery').show()
                                } else {
                                    $('.view-delivery-fee').html('We are sorry, we cannot ship to your location.')
                                    $('.continue-delivery').hide()
                                }

                                $('.calculate-fee').text('Calculate fee')
                                $('.calculate-fee').removeAttr('disabled')
                                $('.continue-delivery').removeAttr('disabled')
                            }

                            if (queryType == 'checkout') {
                                var qtty = deliveryFee

                                var deliveryContactName = $('#delivery-contact-name').val()
                                var deliveryPhoneNumber = $('#delivery-phone-number').val()
                                var deliveryAddress = $('#delivery-address').val()
                                var deliveryApartment = $('#delivery-apartment').val()
                                var deliveryCity = $('#delivery-city').val()
                                var deliveryZipCode = $('#delivery-zip-code').val()

                                var fullDeliveryAddress = deliveryAddress + ' ' + deliveryApartment + ' ' + deliveryCity + ' ' + deliveryZipCode

                                function extractAmount(inputString) {
                                    // Regular expression to find a number (with optional decimal) preceded by "$ " and enclosed in "[]".
                                    // The \d+ matches one or more digits.
                                    // (\.\d{2})? matches an optional decimal point followed by two digits.
                                    // \[ \$(\d+\.?\d*)\ ] matches the pattern "[ $", then captures the number, then matches " ]".
                                    const regex = /\[ \$(\d+\.?\d*)\ ]/;

                                    // Execute the regex on the input string.
                                    const match = inputString.match(regex);

                                    // If a match is found, the captured group (the number) will be at index 1.
                                    if (match && match[1]) {
                                        // Convert the captured string to a floating-point number and return it.
                                        return parseFloat(match[1]);
                                    } else {
                                        // If no match is found, return null.
                                        return null;
                                    }
                                }

                                if (deliveryFee != 0) {
                                    var products = []
                                    var customizations = 0

                                    $.getJSON('/cart.js', function (cart) {
                                        $(cart.items).each(function () {
                                            if (Object.keys(this.properties).length != 0 && this.properties.hasOwnProperty('Extras')) {
                                                var extraAmount = extractAmount(this.properties['Extras'])

                                                if (extraAmount && extraAmount != 0) {
                                                    var customizationProduct = {
                                                        title: 'Customization cost for ' + this.product_title,
                                                        price: extraAmount * this.quantity,
                                                        quantity: 1,
                                                        requires_shipping: false,
                                                        product_id: customizations + 1,
                                                        properties: [{
                                                            name: 'Extras',
                                                            value: this.properties['Extras']
                                                        }]
                                                    }

                                                    products.push(customizationProduct)
                                                }
                                            }

                                            var cartProduct = {
                                                quantity: this.quantity,
                                                product_id: this.product_id,
                                                variant_id: this.variant_id
                                            }

                                            products.push(cartProduct)
                                        })

                                        var deliveryFeeProduct = {
                                            price: deliveryFee,
                                            title: 'Delivery Fee',
                                            quantity: 1,
                                            requires_shipping: false,
                                            product_id: 1
                                        }

                                        products.push(deliveryFeeProduct)

                                        products = JSON.stringify(products)

                                        attributes = []

                                        attributes.push({
                                            name: 'Note',
                                            value: $('#Cart-note').val()
                                        })

                                        attributes.push({
                                            name: 'Delivery Contact',
                                            value: deliveryContactName
                                        })

                                        attributes.push({
                                            name: 'Contact Phone',
                                            value: deliveryPhoneNumber
                                        })

                                        attributes.push({
                                            name: 'Delivery Address',
                                            value: fullDeliveryAddress
                                        })

                                        var referralEmail = $('#cart-referral-email').val() ? $('#cart-referral-email').val().trim() : '';
                                        if (referralEmail.length > 0) {
                                            attributes.push({
                                                name: 'Referral Email',
                                                value: referralEmail
                                            })
                                            $.ajax({
                                                type: 'POST',
                                                url: '/cart/update.js',
                                                data: {
                                                    attributes: {
                                                        'Referral Email': referralEmail
                                                    }
                                                },
                                                dataType: 'json'
                                            });
                                        }

                                        attributes = JSON.stringify(attributes)

                                        if (localStorage.getItem('discount') || $('#coupon-code').val() != '') {

                                            if (!localStorage.getItem('discount')) {
                                                applyCoupon()
                                                new Promise(resolve => setTimeout(resolve, 5000))
                                            }

                                            var discountCode = JSON.parse(localStorage.getItem('discount'))
                                            var cartTotal = 0
                                            var discountTotal = 0

                                            $.each(cart.items, function (index, item) {
                                                cartTotal += item.presentment_price * item.quantity
                                            })

                                            if (discountCode.price_rule.target_type != 'shipping_line') {
                                                if (discountCode.price_rule.value_type == 'percentage') {
                                                    var percentage = discountCode.price_rule.value
                                                    percentage = percentage.replace('-', '')
                                                    percentage = percentage.split('.')[0]

                                                    discountTotal = cartTotal * percentage / 100
                                                } else if (discountCode.price_rule.value_type == 'fixed_amount') {
                                                    var amount = discountCode.price_rule.value
                                                    amount = amount.replace('-', '')
                                                    amount = amount.split('.')[0]

                                                    discountTotal = amount
                                                }

                                                var discount = {
                                                    description: discountCode.price_rule.title,
                                                    value_type: "fixed_amount",
                                                    value: discountTotal,
                                                    amount: discountTotal,
                                                    title: discountCode.price_rule.title
                                                }

                                                discount = JSON.stringify(discount)

                                                $.ajax({
                                                    beforeSend: function (request) {
                                                        request.setRequestHeader("Authorization", 'Bearer 1|JJ4NzBl52YAilFok9knvLnLMyLsjYdvGsOZiVeOA5a9cc538');
                                                    },
                                                    type: "POST",
                                                    dataType: "json",
                                                    url: 'http://v1.tyboapi.com/api/mr-meal/cart-draft-order',
                                                    async: false,
                                                    data: {
                                                        products: products,
                                                        order_attributes: attributes,
                                                        discount: discount
                                                    },
                                                    success: function (response) {
                                                        window.location = response[0].draft_order.invoice_url
                                                    },
                                                    error: function (XMLHttpRequest, textStatus, errorThrown) {
                                                        console.log(errorThrown)
                                                    }
                                                })
                                            }
                                        } else {
                                            $.ajax({
                                                beforeSend: function (request) {
                                                    request.setRequestHeader("Authorization", 'Bearer 1|JJ4NzBl52YAilFok9knvLnLMyLsjYdvGsOZiVeOA5a9cc538');
                                                },
                                                type: "POST",
                                                dataType: "json",
                                                url: 'http://v1.tyboapi.com/api/mr-meal/cart-draft-order',
                                                async: false,
                                                data: {
                                                    products: products,
                                                    order_attributes: attributes
                                                },
                                                success: function (response) {
                                                    window.location = response[0].draft_order.invoice_url
                                                },
                                                error: function (XMLHttpRequest, textStatus, errorThrown) {
                                                    console.log(errorThrown)
                                                }
                                            })
                                        }
                                    })
                                } else {
                                    $('.view-delivery-fee').html('We are sorry, we cannot ship to your location.')
                                    $('.continue-delivery').hide()
                                }

                                /*if (qtty != 0) {
                                  checkDeliveryExists()
                
                                  var queryData = {
                                    "id": 39600867180708,
                                    "quantity": 0
                                  } 
                      
                                  jQuery.ajax({ 
                                    type: 'POST',
                                    url: '/cart/change.js',
                                    data: queryData,
                                    dataType: 'json',
                                    success: function() {   
                                      console.log() 
                                    }  
                                  }); 
                
                                  var queryData = {
                                    "id": 39600867180708,
                                    "quantity": qtty,
                                    "attributes": {
                                      'Delivery Contact': deliveryContactName,
                                      'Contact Phone': deliveryPhoneNumber,
                                      'Delivery Address': fullDeliveryAddress
                                    }
                                  }
                      
                                  jQuery.ajax({
                                    type: 'POST',
                                    url: '/cart/add.js',
                                    data: queryData,
                                    dataType: 'json',
                                    success: function() {   
                                      $('.cart__checkout-button').trigger('click')   
                                    }  
                                  });
                                }*/
                            }
                        } else {
                            $('.view-delivery-fee').html('We are sorry, we cannot ship to your location.')
                            $('.continue-delivery').text('Continue')
                            $('.continue-delivery').removeAttr('disabled')
                            $('.calculate-fee').removeAttr('disabled')
                            $('.continue-delivery').hide()
                        }
                    },
                    error: function (XMLHttpRequest, textStatus, errorThrown) {
                        console.log(errorThrown)
                    }
                })
            }
        }

        //When user clicks on calculate FEE for delivery
        $('.calculate-fee').click(function () {
            $('.calculate-fee').attr('disabled', 'disabled')
            $('.continue-delivery').attr('disabled', 'disabled')
            $('.calculate-fee').text('Calculating..')
            calculateDeliveryFee('calculate')
        })

        $('.custom-tybo-checkout').click(function () {
            $('.tybo-qty-validation').hide()
            $('.tybo-shipping-validation').hide()
            var shippingMethod = $('.shipping-method-tybo').val()

            $.getJSON('/cart.js', function (cart) {
                var cartHasMeals = false
                var cartHasCatering = false
                var mealsCount = 0

                $(cart.items).each(function () {
                    //if (this.product_type == 'Weekly Meal' || this.product_type == 'Custom Meal' || this.product_type == 'Healthy Breakfast' || this.product_type == 'Smoothies') {  
                    mealsCount += this.quantity
                    cartHasMeals = true
                    //}

                    if (this.product_type == 'Catering') {
                        cartHasCatering = true
                    }
                })

                if (cartHasMeals && mealsCount < 10) {
                    $('.tybo-qty-validation').show()
                } else if (!cartHasCatering) {
                    if (!shippingMethod.length) {
                        $('.tybo-shipping-validation').show()
                    } else {
                        if (shippingMethod == 'Delivery') {
                            calculateDeliveryFee('checkout')
                        } else {
                            var referralEmail = $('#cart-referral-email').val() ? $('#cart-referral-email').val().trim() : '';
                            $.ajax({
                                type: 'POST',
                                url: '/cart/update.js',
                                data: {
                                    attributes: {
                                        'Referral Email': referralEmail
                                    }
                                },
                                dataType: 'json'
                            }).always(function () {
                                $('.cart__checkout-button').trigger('click');
                            });
                        }
                    }
                }
            })
        })
    }
});
